


























import {Component, Prop, Vue} from "vue-property-decorator";
import {Film} from "@/modules/Rhizome/interfaces/film.interface";

@Component({
  components: {

  }
})

export default class FilmListItem extends Vue {
  @Prop() film: Film.IFilm;
  @Prop() status: string;

  statuses = Film.FilmState;

  clearConnection() {
    this.$emit('clearConnection');
  }
}
